'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.THREAD_COMMENT), _defineProperty(_Record, 'timestamp', null), _defineProperty(_Record, 'contentType', null), _defineProperty(_Record, 'text', null), _defineProperty(_Record, 'richText', null), _defineProperty(_Record, 'sender', (0, _immutable.Map)()), _defineProperty(_Record, 'status', (0, _immutable.Map)()), _defineProperty(_Record, 'attachments', (0, _immutable.List)()), _defineProperty(_Record, 'id', null), _Record), 'CommentMessageMetadata');
module.exports = exports['default'];